import type { Neighborhood } from "../../types/neighborhood";

export type ServiceAreaSearchCenter = {
  lat: number;
  lng: number;
};

export function serviceAreaSearchCenterFromNeighborhoods(
  neighborhoods: Neighborhood[],
  fallbackCenter?: ServiceAreaSearchCenter | null,
): ServiceAreaSearchCenter | null {
  if (fallbackCenter) {
    return fallbackCenter;
  }

  const valid = neighborhoods.filter((n) => n.lat !== 0 || n.lng !== 0);
  if (valid.length === 0) {
    return null;
  }

  const lat = valid.reduce((sum, n) => sum + n.lat, 0) / valid.length;
  const lng = valid.reduce((sum, n) => sum + n.lng, 0) / valid.length;
  return { lat, lng };
}
